import request from '@/utils/request'

// 查询列表
export function selectPage(query) {
  return request({
    url: "/purchase/contract/getPage",
    method: "get",
    params: query
  });
}

// 查询明细
export function selectOne(id) {
  return request({
    url: '/purchase/contract/'+id,
    method: "get"
  });
}

// 新增
export function addData(data) {
  return request({
    url: "/purchase/contract",
    method: "post",
    data: data
  });
}

// 修改
export function updateData(data) {
  return request({
    url: "/purchase/contract",
    method: "put",
    data: data
  });
}

// 提交
export function submitData(id) {
  return request({
    url: "/purchase/contract/"+id,
    method: "put"
  });
}

// 审批
export function approvalData(data) {
  return request({
    url: "/purchase/contract/inspectOrder",
    method: "put",
    data: data
  });
}

// 删除
export function delData(id) {
  return request({
    url: "/purchase/contract/"+id,
    method: "delete"
  });
}



